import AdminLayout from "component/admin/adminLayout";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Dashboard from "./pages/dashboard";
import System from "./pages/system";
import Application from "./pages/application";
import User from "./pages/user";
import SignIn from "pages/my/signIn";
import Product from "./pages/product";
import AdminMgmt from "./pages/admin";

function OwnerRoute({ children }) {
  const adminType = useSelector((state) => state.user.adminType);
  if (adminType && adminType !== "CD0101") {
    return <Navigate to={`${process.env.REACT_APP_CLIENT_URL}admin/application`} replace />;
  }
  return children;
}

function Admin() {
  const userPayload = useSelector((state) => state.user);
  const isAdmin = userPayload.userId !== "" && userPayload.adminYn === "Y";

  return (
    <Routes>
      <Route index element={isAdmin ? <Navigate to="application" replace /> : <SignIn type="admin" />} />

      <Route element={<AdminLayout />}>
        <Route path="application" element={<Application />} />
        <Route path="user" element={<User />} />
        <Route path="system" element={<System />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="product" element={<Product />} />
        <Route path="admin" element={<OwnerRoute><AdminMgmt /></OwnerRoute>} />
        <Route
          path="*"
          element={<Navigate to={process.env.REACT_APP_CLIENT_URL} replace />}
        />
      </Route>
    </Routes>
  );
}
export default Admin;
